import { Component, computed, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { LinkComponent } from '@teamfoster/sdk/button';
import { ShowCookieSettings } from '@teamfoster/sdk/cookie-ngrx';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { JsonLdComponent } from 'src/app/seo/components/json-ld/json-ld.component';
import { SocialChannel } from 'src/app/social-media/models';
import * as fromMenu from '@teamfoster/sdk/menu-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { RouterLink } from '@angular/router';
import { SocialChannelButtonsComponent } from 'src/app/social-media/components/social-channel-buttons/social-channel-buttons.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [
    FromDictionaryPipe,
    JsonLdComponent,
    LinkComponent,
    IconComponent,
    RouterLink,
    SocialChannelButtonsComponent,
    fromMenu.OfMenuTypePipe,
  ],
})
export class FooterComponent {
  footerMenuLeft = input<fromMenu.MenuEntry>();
  footerMenuRight = input<fromMenu.MenuEntry>();
  footerMenuBottom = input<fromMenu.MenuEntry>();

  private dict = new FromDictionaryPipe();

  domain = input<string>('');
  socials = input<SocialChannel[]>([]);

  schema = computed(() => ({
    '@context': 'http://schema.org',
    '@type': 'Organization',
    'name': this.dict.transform('meta-titel'),
    'url': this.domain(),
    'logo': `${this.domain()}/assets/gfx/logo.svg`,
    'contactPoint': {
      '@type': 'ContactPoint',
      'email': this.dict.transform('contact-email'),
      'contactType': 'customer service',
    },
    'sameAs': this.socials().map(s => s.url),
  }));

  year = new Date().getFullYear();

  isMsc = computed(() => this.domain().includes('msc'));
  isSuriname = computed(() => this.domain().includes('sr'));
  isNL = computed(() => this.domain().includes('.nl'));
  isCom = computed(() => this.domain().includes('.com'));
  isPa = computed(() => this.domain().includes('personenalarmering'));

  constructor(
    private store: Store,
    private lang: LanguageService
  ) {}

  openCookie() {
    this.store.dispatch(ShowCookieSettings());
  }
}
